import { Feature, PlanType, Vertical } from './types';
import { PLAN_TYPES_ASCENDING, resolvePlanType } from './getEstablishmentFeaturesByPlan';
import { BUSINESS_CATEGORIES, getBusinessCategoryVertical } from './business-categories';

export const VERTICALS: Vertical[] = ['GASTRONOMY'];

export const VERTICAL_FEATURES_BY_PLAN: Partial<
  Record<Vertical, Partial<Record<PlanType, Feature[]>>>
> = {
  GASTRONOMY: { [PlanType.ADVANCED]: ['TABLES'] },
};

export const getVerticalBusinessCategories = (vertical: Vertical): string[] =>
  BUSINESS_CATEGORIES.filter(
    businessCategory => getBusinessCategoryVertical(businessCategory) === vertical,
  );

export const getEstablishmentVerticals = (categories: unknown): Vertical[] => {
  const categoryList = typeof categories === 'string' ? [categories] : categories;

  if (!Array.isArray(categoryList)) {
    return [];
  }
  return VERTICALS.filter(vertical =>
    categoryList.some(category => getBusinessCategoryVertical(category) === vertical),
  );
};

const getVerticalFeatures = (vertical: Vertical, planType: PlanType): Feature[] =>
  VERTICAL_FEATURES_BY_PLAN[vertical]?.[planType] ?? [];

export const getVerticalFeaturesByPlan = (plan: string, verticals: Vertical[]): Feature[] => {
  const planType = resolvePlanType(plan);

  if (!planType) {
    return [];
  }
  const includedPlanTypes = PLAN_TYPES_ASCENDING.slice(
    0,
    PLAN_TYPES_ASCENDING.indexOf(planType) + 1,
  );

  return verticals.flatMap(vertical =>
    includedPlanTypes.flatMap(includedPlanType => getVerticalFeatures(vertical, includedPlanType)),
  );
};

export const getVerticalPlanTypeForFeature = (
  feature: Feature,
  verticals: Vertical[],
): `${PlanType}` | null =>
  PLAN_TYPES_ASCENDING.find(planType =>
    verticals.some(vertical => getVerticalFeatures(vertical, planType).includes(feature)),
  ) ?? null;
